import { Controller } from "@hotwired/stimulus"

// Fixed 48px bar at the bottom on mobile: [+ Добавить] [↶ Undo] [↷ Redo] [≡ Меню].
// Undo/Redo delegate to the hotkeys controller via regular data-action; this
// controller only dispatches events that the bottom sheet listens to.
export default class extends Controller {
  openLibrary() {
    this.dispatch("open-library", { bubbles: true })
  }

  openMenu() {
    this.dispatch("open-menu", { bubbles: true })
  }
}
